export const zobjectCreated = (subpatch, {zobject}) => {
    let {_text} = zobject;

    subpatch.instances.forEach(
        instance => {
            instance.registerObject(
                zobject,
                instance.createZObject(0,0,_text));
        });
};

export const zmessageCreated = (subpatch, {zmessage}) => {
    let {dataType} = zmessage;

    subpatch.instances.forEach(
        instance => {
            let _zmsg = instance.createZMessage(0,0,dataType);
            instance.registerObject(
                zmessage,
                _zmsg);
                
        });
};

export const inletCreated = (subpatch, {inlet , isInstanceInlet}) => {
    subpatch.instances.forEach(
        instance => {
            instance.registerObject(
                inlet,
                isInstanceInlet ?
                    instance.newInstanceInlet() :
                    instance.newInlet());
        });
};

export const outletCreated = (subpatch, {outlet}) => {
    subpatch.instances.forEach(
        instance => {
            instance.registerObject(
                outlet,
                instance.newOutlet());
        });
};


